import { useCallback } from 'react'
import {
  getClaimsPerformanceReport,
  type ClaimsPerformanceReportResult,
  type ReportBucketType,
} from '@services/api/reports/finance.api'
import { useFinanceReportQuery } from '@hooks/reports/useFinanceReportQuery'

export type ClaimsPerformanceFinanceData = ClaimsPerformanceReportResult

export type UseClaimsPerformanceFinanceResult = {
  loading: boolean
  error: string | null
  data: ClaimsPerformanceFinanceData | null
  bucketLabel: string
}

export function useClaimsPerformanceFinance(
  toolbarSelection: Record<string, string>,
): UseClaimsPerformanceFinanceResult {
  const getBucketFromData = useCallback(
    (data: ClaimsPerformanceReportResult): ReportBucketType =>
      data.averageDaysToPaymentByPeriod.bucket,
    [],
  )

  return useFinanceReportQuery({
    toolbarSelection,
    fetchReport: getClaimsPerformanceReport,
    getBucketFromData,
    errorMessage: 'Failed to load claims performance data',
  })
}
